<template>
  <div class="tile is-ancestor">
    <div class="tile is-parent">
      <div class="tile is-child box">
        <div class="wysiwyg">
          <h1>Personal access token</h1>
          <h4>Make sure to copy your new personal access token now. You won’t be able to see it again!</h4>
          <h4>If you forgot your personal access token, revoke it and generate again!</h4>
          <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">Personal access token</label>
            </div>
            <div class="control is-fullwidth">
              <input v-model="token" rows=4 id="token" class="input" type="text" placeholder="Checking your personal token" readonly>
            </div>
          </div>
          <div class="control is-horizontal">
            <div class="control-label">
            </div>
            <div class="control is-fullwidth">
              <button class="button is-primary" @click="clipboard()" v-if="checkStatus() === 99">Copy to Clipboard</button>
              <button class="button is-normal" @click="generatepersonaltoken()" v-if="checkStatus() === 0">Generate</button>
              <button class="button is-danger" @click="revokepersonaltoken()" v-if="checkStatus() === 1">Revoke</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from 'util'

export default {
  data () {
    return {
      token: '',
      tokenstatus: -1
    }
  },
  methods: {
    generatepersonaltoken () {
      this.$http.post(this.$store.state.api.personaltoken).then((response) => {
        if (response.status === 200) {
          this.token = response.data
          // document.getElementById('token').value = response.data
          this.tokenstatus = 99
        }
      }).catch((error) => {
        console.log(util.inspect(error))
      })
    },
    revokepersonaltoken () {
      this.$http.delete(this.$store.state.api.personaltoken).then((response) => {
        // document.getElementById('token').value = 'Click Generate button for the new token'
        this.token = 'Click Generate button for the new token'
        this.tokenstatus = 0
      }).catch((error) => {
        console.log(util.inspect(error))
      })
    },
    clipboard () {
      var token = document.getElementById('token')
      token.select()
      document.execCommand('copy')
      this.tokenstatus = 1
      // document.getElementById('token').value = 'YOU HAVE A PERSONAL TOKEN'
      this.token = 'YOU HAVE A PERSONAL TOKEN'
    },
    checkStatus () {
      return this.tokenstatus
    }
  },
  mounted () {
    this.$http.get(this.$store.state.api.personaltoken).then((response) => {
      if (response.status === 200) {
        // document.getElementById('token').value = 'YOU HAVE A PERSONAL TOKEN'
        this.token = 'YOU HAVE A PERSONAL TOKEN'
        this.tokenstatus = 1
      }
    }).catch((error) => {
      if (error.response.status === 400) {
        // document.getElementById('token').value = error.response.statusText
        this.token = error.response.statusText
        this.tokenstatus = -2
      } else if (error.response.status === 404) {
        // document.getElementById('token').value = 'Click Generate button for the new token'
        this.token = 'Click Generate button for the new token'
        this.tokenstatus = 0
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// Personal-Token.vue?01fd8198